import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path d="M21 5H3C2.4 5 2 5.4 2 6V10V11V19C2 19.6 2.4 20 3 20H21C21.6 20 22 19.6 22 19V11V10V6C22 5.4 21.6 5 21 5ZM20 7V9H4V7H20ZM4 18V12H20V18H4Z" />,
  'CreditCard'
)
